import React, { Fragment, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { AdminStatisticsCardElement } from "../components/AdminStatisticsCardElement";
import SvgConstructOrangeRibbonCert from "../assets/SvgConstructOrangeRibbonCert";
import { PageTitleController } from "../components/PageTitleController";
import { BsRocketFill } from "react-icons/bs";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import AxisSpinner from "../components/AxisSpinner";
import Row from "react-bootstrap/Row";
import { ShiftTypeString } from "../util/ShiftOptionsSelection";
import { ShiftLink } from "../util/Links";
import { useAuth } from "../context/AuthContext";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { ShiftTableDetailModal } from "../modals/ShiftTableDetailModal";

const LiveShifts = () => {
  const [loading, setLoading] = useState(true);
  const { authAxios, token } = useAuth();
  const [dataSource, setDataSource] = useState([]);
  const [dataListSize, setDataListSize] = useState(30);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectDetail, setSelectDetail] = useState(null);

  const fetchHistory = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          size: dataListSize,
        },
      };

      const page = await authAxios().get(
        "/api/backoffice/shifts/history",
        config,
      );

      setDataSource(page.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  useEffect(() => {
    fetchHistory();

    let timer = setInterval(() => {
      fetchHistory();
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const SpinnerOrData = () => {
    if (loading && dataSource?.length === 0)
      return <AxisSpinner loading={loading} />;

    return (
      <Fragment>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Reference</th>
              <th>Trust</th>
              <th>Facility</th>
              <th>Ward</th>
              <th>Grade</th>
              <th>Type</th>
              <th>Status</th>
              <th>Time</th>
            </tr>
          </thead>
          <TransitionGroup component="tbody">
            {dataSource?.map((shift) => {
              return (
                <CSSTransition
                  timeout={200}
                  classNames="SlideIn"
                  key={shift?.statusId}
                >
                  <tr
                    onClick={() => {
                      setSelectDetail(shift);
                      setDetailModalVisible(true);
                    }}
                  >
                    <td>{ShiftLink(shift)}</td>
                    <td>{shift?.trust?.shortName}</td>
                    <td>{shift?.facility?.name}</td>
                    <td>{shift?.ward?.identifier}</td>
                    <td>{shift?.grade}</td>
                    <td>{ShiftTypeString(shift?.shiftType)}</td>
                    <td className={"text-capitalize"}>
                      {shift?.status.toLowerCase()}
                    </td>
                    <td>{AxisDateTimeFull(shift?.start)}</td>
                  </tr>
                </CSSTransition>
              );
            })}
          </TransitionGroup>
        </Table>
      </Fragment>
    );
  };

  const getStatsCards = () => {
    return (
      <Fragment>
        <div className={"axis-card-container"}>
          <Row xs={1} md={2} lg={3} className={"g-3"}>
            {AdminStatisticsCardElement(
              "Open Shifts",
              "/api/backoffice/overview/open_shifts",
              <SvgConstructOrangeRibbonCert floatType={"right"} />,
              "/shifts",
              { redirectKey: "OPEN" },
            )}
            {AdminStatisticsCardElement(
              "Pending Shifts",
              "/api/backoffice/overview/pending_shifts",
              <SvgConstructOrangeRibbonCert floatType={"right"} />,
              "/shifts",
              { redirectKey: "PENDING" },
            )}
            {AdminStatisticsCardElement(
              "Confirmed Shifts",
              "/api/backoffice/overview/confirmed_shifts",
              <SvgConstructOrangeRibbonCert floatType={"right"} />,
              "/shifts",
              { redirectKey: "CONFIRMED" },
            )}
          </Row>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <PageTitleController
          title={"Live Shifts"}
          icon={<BsRocketFill className={"icon-right-spacing"} />}
        />
      </Row>

      {getStatsCards()}

      <br />

      {SpinnerOrData()}

      <ShiftTableDetailModal
        shift={selectDetail}
        close={() => setDetailModalVisible(false)}
        visible={detailModalVisible}
      />
    </Fragment>
  );
};

export default LiveShifts;
